
        ;
        'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browser = require('assets/util/browser.js');
var DomID = 'FCIM';

var _module = {
  init: function init(data) {
    if (browser.newThanIe8()) {
      getTheIMSource(function () {
        window.FCIM.init({
          id: DomID,
          pid: data.pid,
          pname: data.pname,
          cityId: data.cityId
        });
      });
    } else {
      console.log('浏览器版本过低，无法启动IM套件');
    }
  },
  chat: function chat(data) {
    if (browser.newThanIe8()) {
      if ($('#' + DomID).length) {
        // 这个时候IM组件还没有初始化，不开启聊天
        return;
      }
      window.FCIM.chat(data.toUid, {
        nickname: data.nickname,
        avatar: data.avatar
      });
    } else {
      console.log('浏览器版本过低，无法启动IM套件');
    }
  }
};

function getTheIMSource(callbackFn) {
  var domainPrefix = 'focus';
  var domain = null;
  var url = '';
  var domainParts = window.location.hostname.split('.');
  for (var i = 0, len = domainParts.length; i < len; i++) {
    if (domainParts[i].indexOf(domainPrefix) >= 0) {
      domain = domainParts[i];
      break;
    }
  }
  if (domain === domainPrefix) {
    // 线上环境
    url = '//t-res.focus-img.cn/front-end/ecology/pc-im/im-new.js';
  } else {
    // 测试环境
    url = '//focus-res-test.cn/front-end/ecology/pc-im/im-new.js';
  }
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = function () {
    callbackFn();
  };
  script.src = url;

  document.getElementsByTagName('head')[0].appendChild(script);
}

exports['default'] = _module;;
    


// WEBPACK FOOTER //
// ./src/module/common/common-float-im/index.js